import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  editPageLinks = new BehaviorSubject([]);
  editPageLinks$ = this.editPageLinks.asObservable();
  sidebarLessNonLoggedInViewActive = new BehaviorSubject(false);
  sidebarLessNonLoggedInViewActive$ = this.sidebarLessNonLoggedInViewActive.asObservable();

  public filterSectionSubject = new BehaviorSubject(false);
  public showApplyProgramCommonHeader = new BehaviorSubject(true);
  constructor(
    private router: Router,
  ) { }

  setEditPageLinks(links) {
    this.editPageLinks.next(links)
  }

  scrollFormsToTop() {
    const wrapper = document.getElementById('kt_wrapper')
    if(wrapper) {
      wrapper.scrollTop = 0
    }
  }

  // Fix (2026-08-26) — `PROFILE_NAV_LINKS` routes are always bare paths
  // (no query params/fragment), but `this.router.url` can legitimately
  // carry either (e.g. tracking params, a redirect artifact). All 4 methods
  // below compared the raw `this.router.url` against `e.route` with strict
  // equality -- if the current URL ever had anything extra on it, the match
  // would silently fail and every one of these would just do nothing, with
  // zero error feedback. Reported live: "Next Step" saved successfully but
  // never navigated, on an otherwise fully-valid, fully-filled form.
  private currentPath(): string {
    return this.router.url.split('?')[0].split('#')[0];
  }

  goToNextPage() {
    this.editPageLinks$.pipe(take(1)).subscribe((res) => {
      const foundRoute = res.findIndex((e) => e.route === this.currentPath());
      if (foundRoute >= 0 && res[foundRoute + 1]) {
        this.router.navigate([res[foundRoute + 1].route])
        this.scrollFormsToTop()
      }
    })
  }
  goToPreviousPage() {
    this.editPageLinks$.pipe(take(1)).subscribe((res) => {
      const foundRoute = res.findIndex((e) => e.route === this.currentPath());
      if (foundRoute >= 0 && res[foundRoute -1 ]) {
        this.router.navigate([res[foundRoute - 1].route])
        this.scrollFormsToTop()
      }
    })
  }

  async getNextRoute() {
    let res = await this.editPageLinks$.pipe(take(1)).toPromise()
    const foundRoute = res.findIndex((e) => e.route === this.currentPath());
    if (foundRoute >= 0 && res[foundRoute + 1]) {
      return res[foundRoute + 1].route
    }
    return undefined
  }
  async getPreviousRoute() {
    let res = await this.editPageLinks$.pipe(take(1)).toPromise()
    const foundRoute = res.findIndex((e) => e.route === this.currentPath());
    if (foundRoute >= 0 && res[foundRoute - 1]) {
      return res[foundRoute - 1].route
    }
    return undefined
  }

  private readonly accountTypeRoutes: Record<string, string> = {
    startup: 'startups',
    corporate: 'corporates',
    investor: 'investors',
    mentor: 'mentors',
    service_provider: 'service-provider',
    partner: 'partners',
    program_office: 'program-office-members',
    individual: 'individuals',
  };

  openProfileDetails(accountType: string, profileUUID: string, companyName: string) {
    const segment = this.accountTypeRoutes[accountType];
    if (!segment || !profileUUID || !companyName) return;
    const slug = companyName.split(' ').join('-').toLocaleLowerCase();
    const url = this.router.serializeUrl(this.router.createUrlTree(['/' + segment + '/profile/' + profileUUID, slug]));
    window.open(url, '_blank');
  }
}
